import React from 'react'
import './styles/CategoryAreas.scss';

const CategoryAreas = (props) => {
  let { therapy_areas, active_category } = props;

  return  active_category?  (
      <div className="category-areas">
        {therapy_areas.map(area => (
          <span className="md-caption" key={area._id}>{area.name}</span>
        ))}
      </div>
    )
    : null;
}


CategoryAreas.defaultProps = {
  therapy_areas: [],
  active_category: null
}

export default CategoryAreas;



// WEBPACK FOOTER //
// ./src/components/ui/CategoryAreas.jsx